import { useTranslation } from 'react-i18next'
import { Stripe, StripeElements } from '@stripe/stripe-js'

import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

import { Payment } from '@/pages/diagnostic/components/Payment'

export type PayConsultationDialogProps = {
  isPaymentReceiverStripeActivated: boolean
  open: boolean
  onClose: () => void
  onPaymentStart: (stripe: Stripe, elements: StripeElements) => void
  paymentLoading: boolean
  price: number
}

export default function PayConsultationDialog(props: PayConsultationDialogProps) {
  const { isPaymentReceiverStripeActivated, open, onClose, onPaymentStart, paymentLoading, price } = props

  const { t } = useTranslation()

  const handleClose = () => {
    onClose()
  }

  const handleStartPayment = ({ stripe, elements }: { stripe: Stripe; elements: StripeElements }) => {
    onPaymentStart(stripe, elements)
  }

  return (
    <Dialog
      disablePortal
      open={open}
      onClose={(_event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (reason !== 'backdropClick') handleClose()
      }}
      PaperProps={{ sx: { maxWidth: (theme) => theme.breakpoints.values.sm, overflow: 'visible' } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' }}>
        {t('page.waitingRooms.reserveConsultationDialog.payment_title')}
        <Tooltip title={t('common:button.close.tooltip')}>
          <IconButton onClick={handleClose}>
            <CloseRoundedIcon />
          </IconButton>
        </Tooltip>
      </DialogTitle>
      <DialogContent>
        <Payment
          consultationPrice={price}
          isConfiguringPayment={false}
          isDoctorStripePaymentActivated={isPaymentReceiverStripeActivated}
          isDoctor={false}
          isPaid={false}
          isPaying={paymentLoading}
          isUpdatingPrice={false}
          onStartPayment={handleStartPayment}
        />
      </DialogContent>
    </Dialog>
  )
}
